// extracted by mini-css-extract-plugin
export var bodySections = "_3y-8";
export var gray = "_3y-7";
export var green = "_3y-4";
export var iconContainer = "_3y-9";
export var iconWidgetContainer = "_3y-1";
export var phoneIcon = "_3y-2";
export var red = "_3y-5";
export var statusDot = "_3y-3";
export var widgetContainer = "_3y-0";
export var yellow = "_3y-6";